import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversityService} from '../../../shared/services/university.service';
import {PcbMappingService} from '../../../shared/services/pcb-mapping.service';
import {UniversityCourseDescriptionService} from '../../../shared/services/university-course-description.service';
import {environment} from '../../../../environments/environment';

import {UtilsService} from '../../../shared/services/utils.service';

interface OverviewEditorBlock {
    type: 'content' | 'table';
    value: string;
}

@Component({
    selector: 'app-university-courses',
    templateUrl: './university-courses.component.html',
    styleUrls: ['./university-courses.component.scss']
})
export class UniversityCoursesComponent implements OnInit {
    toggleMenu = false;
    universityId: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    pcbMappings: any;
    university: any;
    dataExists: any = false;
    submitting: any = false;
    submitted: any = false;
    editorBlocks: OverviewEditorBlock[] = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private pcbMappingService: PcbMappingService,
                private universityService: UniversityService,
                private universityCourseDescriptionService: UniversityCourseDescriptionService) {
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
        this.getPCBMapping();
        this.universityCourseDescriptionService.detailByAdmin(this.universityId).subscribe(data => {
            this.dataExists = !!(data && data['info']);
            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    submit() {
        this.submitting = true;
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);
        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
        };
        if (this.dataExists) {
            this.universityCourseDescriptionService.updateByAdmin(this.universityId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        } else {
            this.universityCourseDescriptionService.createByAdmin(this.universityId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        }
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
            }
        });
    }

    getPCBMapping() {
        this.pcbMappingService.getByAdmin(this.universityId, {'page': -1}).subscribe(data => {
            this.pcbMappings = data ? data : [];
        });
    }

    courseCurriculum(data: any) {
        this.router.navigateByUrl('course-curriculum/' + data.id);
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
